export default import.meta.ROLLDOWN_FILE_URL_$5U7x4kA9Ntl0gvpCto8pg